// import React, { Component } from "react";
// import { Stage, Layer, Rect, Text, Group, Line } from "react-konva";
// import Konva from "konva";

// // const CELL_SIZE = 180;
// const GRID_ROWS = 5;
// const GRID_COLS = 8;

// export class KenoGrid extends Component {
//     state = {
//         hovered: null
//     };
//     diamondRefs = {};
//     animatedHits = new Set();
//     layerRef = React.createRef();
//     componentDidMount() {
//         this.pulseAnimation = new Konva.Animation((frame) => {
//             const scale = 1 + Math.sin(frame.time * 0.005) * 0.03;

//             Object.values(this.diamondRefs).forEach((node) => {
//                 if (node) node.scale({ x: scale, y: scale });
//             });
//         }, this.layerRef.current);

//         this.pulseAnimation.start();
//     }
//     render() {
//         const { selected, drawn, toggleNumber, CELL_SIZE, Gridcover,GRID_COLS,GRID_ROWS } = this.props;


//         const numbers = Array.from({ length: 40 }, (_, i) => i + 1);







//         return (
//             <Stage width={GRID_COLS * CELL_SIZE} height={GRID_ROWS * CELL_SIZE}>

//                 <Layer>
//                     {numbers.map((num, index) => {
//                         const row = Math.floor(index / GRID_COLS);
//                         const col = index % GRID_COLS;
//                         const x = col * CELL_SIZE;
//                         const y = row * CELL_SIZE;

//                         const isSelected = selected.includes(num);
//                         const isDrawn = drawn.includes(num);
//                         const isHit = isSelected && isDrawn;

//                         const padding1=3
//                         const padding2=8
//                         const padding3=25

//                         const isHovered = this.state.hovered === num;

//                         return (
//                             <Group key={num} onClick={() => toggleNumber(num)} onTap={() => toggleNumber(num)}
//                                 onMouseEnter={() => {
//                                     this.setState({ hovered: num })
//                                     document.body.style.cursor = 'pointer';
//                                 }}
//                                 onMouseLeave={() => {

//                                     this.setState({ hovered: null })
//                                     document.body.style.cursor = 'default';
//                                 }}
//                                 scale={{ x: isHovered ? 1 : 1, y: isHovered ? 1.005 : 1 }}
//                                 style={{ cursor: 'pointer' }}
//                             >

//                                 {/* Background shadow layer */}
//                                 <Rect
//                                     x={x + padding1}
//                                     y={y + padding1}
//                                     width={CELL_SIZE - padding3}
//                                     height={CELL_SIZE - padding3}
//                                     fill="#000"
//                                     opacity={0.25}
//                                     cornerRadius={12}
//                                 />

//                                 {/* Main 3D-styled cell */}
//                                 <Rect
//                                     x={x + padding1}
//                                     y={y + padding1}
//                                     width={CELL_SIZE - padding3}
//                                     height={CELL_SIZE - padding3}
//                                     cornerRadius={12}
//                                     fill="#1b1f3a"

//                                     shadowColor="black"
//                                     shadowBlur={10}
//                                     shadowOffset={{ x: 5, y: 5 }}
//                                     shadowOpacity={0.4}
//                                 />
//                                 <Rect
//                                     x={x + padding1}
//                                     y={y + padding1}
//                                     width={CELL_SIZE - padding3}
//                                     height={CELL_SIZE - padding3}
//                                     cornerRadius={12}
//                                     // fill="#2d3436"
//                                     fill={isDrawn && isSelected ? "" : isSelected ? "#13b8bc" : ""}
//                                     stroke={isDrawn && isSelected ? "#13b8bc" : isDrawn&&!isSelected ? "#13b8bc" : ""}
//                                     // stroke={isSelected || isHit ? "#8e44ad" : "#34495e"}
//                                     // strokeWidth={isDrawn && isSelected ? "4" : isSelected ? "1" : "0"}
//                                     strokeWidth={isDrawn && isSelected ? "4" : isDrawn&&!isSelected ? "4" : ""}
//                                     // strokeWidth={isSelected || isHit ? 4 : 1}
//                                     // shadowColor={isDrawn && isSelected ? "black" : isSelected ? "transparent" : "transparent"}
//                                     shadowColor="black"
//                                     // shadowBlur={20}
//                                     shadowBlur={isDrawn && isSelected ? 10 : isSelected ? 0 : 0}

//                                     // shadowOffset={{ x: 2, y: 2 }}
//                                     shadowOffset={[
//                                         { direction: 'top', offset: { x: 0, y: -5 } },
//                                         { direction: 'right', offset: { x: 5, y: 0 } },
//                                         { direction: 'bottom', offset: { x: 0, y: 5 } },
//                                         { direction: 'left', offset: { x: -5, y: 0 } },
//                                     ]}
//                                     shadowOpacity={1}
//                                 />
//                                 {(isDrawn && !isHit) && (<Rect

//                                     x={x + padding1}
//                                     y={y + padding1}
//                                     width={CELL_SIZE - padding3}
//                                     height={CELL_SIZE - padding3}
//                                     cornerRadius={12}
//                                     fill={"#1b1f3a"}
//                                     // fill={isDrawn && !isHit ? "#e74c3c" : "#ecf0f1"}
//                                     shadowColor="black"
//                                     shadowBlur={10}
//                                     shadowOffset={{ x: 2, y: 2 }}
//                                     shadowOpacity={0.3}
//                                 //    globalCompositeOperation="destination-out"

//                                 />)}
//                                 {/* <Rect
//                                     x={x}
//                                     y={y}
//                                     width={CELL_SIZE - 10}
//                                     height={CELL_SIZE - 10}
//                                     cornerRadius={12}
//                                     fill="#2d3436"
//                                     stroke={isSelected || isDrawn ? "#8e44ad" : "#34495e"}
//                                     strokeWidth={isSelected || isHit ? 4 : 1}
//                                     shadowColor="black"
//                                     shadowBlur={10}
//                                     shadowOffset={{ x: 2, y: 2 }}
//                                     shadowOpacity={0.3}
//                                 /> */}
//                                 {/* Hit Gem Faceted Diamond */}


//                                 {/* {isHit && (
//                                     <Group x={x + 30} y={y + 30}>
//                                         <Line
//                                             points={[
//                                                 55, 0,   
//                                                 0, 40,   
//                                                 55, 110, 
//                                                 110, 40   
//                                             ]}
//                                             closed
//                                             fill="#2ecc71"
//                                             stroke="#1e8449"
//                                             strokeWidth={3}
//                                             shadowColor="lime"
//                                             shadowBlur={15}
//                                             shadowOpacity={0.7}
//                                         />


//                                         <Line
//                                             points={[
//                                                 55, 0,
//                                                 55, 110,
//                                                 0, 40
//                                             ]}
//                                             closed
//                                             fill="#27ae60"
//                                             opacity={0.7}
//                                         />
//                                         <Line
//                                             points={[
//                                                 55, 0,
//                                                 55, 110,
//                                                 110, 40
//                                             ]}
//                                             closed
//                                             fill="#1abc9c"
//                                             opacity={0.7}
//                                         />
//                                     </Group>
//                                 )} */}














//                                 {isHit && (
//                                     <Group
//                                         x={x + (CELL_SIZE / 6)}
//                                         y={y + (CELL_SIZE / 6)}
//                                         // x={x + 30}
//                                         // y={y + 30}
//                                         ref={(node) => {
//                                             this.diamondRefs[num] = node;

//                                             // Animate only once
//                                             if (node && !this.animatedHits.has(num)) {
//                                                 this.animatedHits.add(num);
//                                                 new Konva.Tween({
//                                                     node,
//                                                     // scaleX: 1.3,
//                                                     // scaleY: 1.3,
//                                                     duration: 0.3,
//                                                     easing: Konva.Easings.EaseInOut,
//                                                 }).play();
//                                             }
//                                         }}
//                                     >
//                                         <Line
//                                             points={[27.5, 0, 0, 40, 55, 110, 110, 40,82.5,0].map(p => p * (CELL_SIZE / 180))}
//                                             // points={[55, 0, 0, 40, 55, 110, 110, 40].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                             fill="#fcbf32"
//                                             // fill="#2ecc71"
//                                             stroke="#fcbf32"
//                                             strokeWidth={3}
//                                             shadowColor="#fcbf32"
//                                             shadowBlur={20}
//                                             shadowOpacity={0.8}
//                                         />
//                                         <Line
//                                             // points={[55, 0, 55, 110, 0, 40].map(p => p * (CELL_SIZE / 180))}
//                                             points={[27.5, 0, 0,40,36.66,40].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                             fill="#fad638"
//                                             // fill="red"
//                                             opacity={1}
//                                         />
//                                         <Line
//                                             points={[27.5, 0, 36.66, 40, 55, 0].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                             // fill="green"
//                                             fill="#f9f486"
//                                             opacity={1}
//                                         />
//                                         <Line
//                                             points={[55, 0, 36.66, 40, 73.33, 40].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                          fill="#fad638"
//                                             // fill="#1abc9c"
//                                             opacity={1}
//                                         />
//                                         <Line
//                                             points={[55, 0, 73.33, 40, 84, 0].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                                   fill="#f9f486"
//                                             // fill="red"
//                                             opacity={1}
//                                         />
//                                         {/* <Line
//                                             points={[87.5,0,73.33,40,110,40].map(p => p * (CELL_SIZE / 180))}
//                                             closed

//                                             // fill="#1abc9c"
//                                             opacity={0.6}
//                                         /> */}
//                                         <Line
//                                             points={[0,40,55,110,36.66,40].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                             // fill="green"
//                                             fill="#fcbf32"
//                                             opacity={1}
//                                         />
//                                         <Line
//                                             points={[36.66,40,55,110,73.33,40].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                             // fill="red"
//                                             fill="#fada4f"
//                                             opacity={1}
//                                         />
//                                         <Line
//                                             points={[73.33,40,55,110,110,40].map(p => p * (CELL_SIZE / 180))}
//                                             closed
//                                             // fill="green"
//                                             fill="#fcbf32"
//                                             opacity={1}
//                                         />
//                                     </Group>
//                                 )}











//                                 {/* Hit Gem Style Layer */}
//                                 {isHit && (
//                                     <Group>
//                                         <Rect
//                                             x={x + padding2}
//                                             y={y + padding2}
//                                             width={CELL_SIZE - 26}
//                                             height={CELL_SIZE - 26}
//                                             cornerRadius={10}
//                                             fillRadialGradientStartPoint={{ x: 0, y: 0 }}
//                                             fillRadialGradientEndPoint={{ x: 0, y: 0 }}
//                                             fillRadialGradientColorStops={[0, "#00ff00", 1, "#008000"]}
//                                             shadowColor="lime"
//                                             shadowBlur={15}
//                                             shadowOpacity={0.8}
//                                         />
//                                     </Group>
//                                 )}

//                                 {/* Hit Gem Style Layer */}
//                                 {isHit && (
//                                     <Group>
//                                         <Rect
//                                             x={x + padding2}
//                                             y={y + padding2}
//                                             width={CELL_SIZE - 26}
//                                             height={CELL_SIZE - 26}
//                                             cornerRadius={10}
//                                             fillRadialGradientStartPoint={{ x: 0, y: 0 }}
//                                             fillRadialGradientEndPoint={{ x: 0, y: 0 }}
//                                             fillRadialGradientColorStops={[0, "#00ff00", 1, "#008000"]}
//                                             shadowColor="lime"
//                                             shadowBlur={15}
//                                             shadowOpacity={0.8}
//                                         />
//                                     </Group>
//                                 )}

//                                 {/* Number label */}
//                                 <Text
//                                     x={x}
//                                     y={y + (CELL_SIZE / 2) - padding3}
//                                     // y={y + 75}
//                                     width={CELL_SIZE - padding3}
//                                     align="center"
//                                     text={num.toString()}
//                                     fontSize={40}
//                                     // fill={isDrawn && !isHit ? "#ff0000" : "#ffff00"}
//                                     fill={isDrawn && isSelected ? "#000000" : isSelected ? "#ffff00" :!isDrawn && !isSelected?"#ffffff": "#ff0000 "}
//                                     fontStyle="bold"
//                                 />
//                             </Group>
//                         );
//                     })}
//                 </Layer>
//                 {Gridcover && <Layer>
//                     <Rect
//                         x={0}
//                         y={0}
//                         // fill={"red"}
//                         width={GRID_COLS * CELL_SIZE} height={GRID_ROWS * CELL_SIZE}
//                     />
//                 </Layer>}
//             </Stage>
//         );
//     }
// }

// export default KenoGrid;






import React, { Component } from "react";
import "./KenoCell.css";

export class KenoGrid extends Component {
    state = {
        hovered: null
    };
    diamondRefs = {};          // num -> DOM node (SVG) for hit gem
    rafId = null;
    animationStart = null;

    componentDidMount() {
        this.startPulse();
    }

    componentWillUnmount() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    startPulse = () => {
        this.animationStart = performance.now();
        const tick = (t) => {
            const elapsed = t - this.animationStart; // ms
            const scale = 1 + Math.sin(elapsed * 0.005) * 0.03; // same formula as Konva

            // Apply transform to all live gem nodes
            Object.entries(this.diamondRefs).forEach(([key, node]) => {
                if (!node || !node.isConnected) return;
                node.style.transform = `scale(${scale})`;
            });

            this.rafId = requestAnimationFrame(tick);
        };
        this.rafId = requestAnimationFrame(tick);
    };

    render() {
        const { selected, drawn, toggleNumber, CELL_SIZE, Gridcover, GRID_COLS, GRID_ROWS } = this.props;

        const numbers = Array.from({ length: 40 }, (_, i) => i + 1);

        return (
            <div
                className="keno-stage"
                style={{
                    width: GRID_COLS * CELL_SIZE,
                    height: GRID_ROWS * CELL_SIZE,
                    position: "relative",
                }}
            >
                {numbers.map((num, index) => {
                    const row = Math.floor(index / GRID_COLS);
                    const col = index % GRID_COLS;
                    const x = col * CELL_SIZE;
                    const y = row * CELL_SIZE;

                    const isSelected = selected.includes(num);
                    const isDrawn = drawn.includes(num);
                    const isHit = isSelected && isDrawn;

                    const isHovered = this.state.hovered === num;

                    // Geometry matching your Konva placement:
                    //   Group x/y offset = CELL_SIZE/6
                    //   Diamond box ~ 110 scaled by (CELL_SIZE/180)
                    const gemOffset = CELL_SIZE / 8;
                    const gemSize = (CELL_SIZE * 110) / 180;

                    return (
                        <div
                            key={num}
                            className={`keno-cell ${isSelected ? "selected" : ""} ${isDrawn ? "drawn" : ""} ${isHit ? "hit" : ""
                                }`}
                            style={{
                                width: CELL_SIZE - 25,
                                height: CELL_SIZE - 25,
                                left: x,
                                top: y,
                                transform: isHovered ? "scale(1.03)" : "scale(1)",
                            }}
                            onClick={() => toggleNumber(num)}
                            onMouseEnter={() => this.setState({ hovered: num })}
                            onMouseLeave={() => this.setState({ hovered: null })}
                        >
                            {/* Background */}
                            <div className="keno-shadow"></div>
                            <div className="keno-bg" style={{
                                background: isHit
                                    ? "#1b1f3a"   // <-- hit background color
                                    : isSelected
                                        ? "#13b8bc"
                                        : "#1b1f3a",
                                boxShadow: isHit
                                    ? "5px 5px -1px rgba(55, 163, 158, 0.4)"
                                    : isSelected
                                        ? "0 0 10px rgba(0,0,0,0.4)"
                                        : "5px 5px 10px rgba(0,0,0,0.4)",
                                // border: isDrawn && !isHit ? "4px solid #13b8bc" : "none",
                                border: isDrawn && !isHit ? "4px solid #13b8bc" : isHit
                                    ? "4px solid #13b8bc"   // <-- hit background color
                                    : isSelected
                                        ? " 4px solid #13b8bc"
                                        : "4px solid #1b1f3a",

                            }}></div>

                            {/* Drawn but not hit (miss) */}
                            {isDrawn && !isHit && <div className="keno-miss"></div>}

                            {/* Hit diamond gem (SVG) */}
                            {isHit && (
                                <svg
                                    ref={(node) => {
                                        // keep refs up to date
                                        if (node) this.diamondRefs[num] = node;
                                        else delete this.diamondRefs[num];
                                    }}

                                    className="keno-gem"
                                    width={CELL_SIZE / 1.6}
                                    height={CELL_SIZE / 1.6}
                                    viewBox="0 0 110 110"


                                    style={{
                                        position: "absolute",
                                        left: gemOffset,
                                        top: gemOffset,
                                        transformOrigin: "55px 55px", // center of viewBox
                                        willChange: "transform",
                                        filter: "drop-shadow(0 0 20px #fcbf32)",
                                    }}
                                >
                                    <polygon
                                        points="27.5,0 0,40 55,110 110,40 82.5,0"
                                        fill="#fcbf32"
                                        stroke="#fcbf32"
                                        strokeWidth="3"
                                    />
                                    <polygon points="27.5,0 0,40 36.66,40" fill="#fad638" />
                                    <polygon points="27.5,0 36.66,40 55,0" fill="#f9f486" />
                                    <polygon points="55,0 36.66,40 73.33,40" fill="#fad638" />
                                    <polygon points="55,0 73.33,40 84,0" fill="#f9f486" />
                                    <polygon points="0,40 55,110 36.66,40" fill="#fcbf32" />
                                    <polygon points="36.66,40 55,110 73.33,40" fill="#fada4f" />
                                    <polygon points="73.33,40 55,110 110,40" fill="#fcbf32" />
                                </svg>
                            )}

                            {/* Number */}
                            <span
                                className="keno-number"
                                style={{
                                    color: isHit
                                        ? "#000"
                                        : isSelected
                                            ? "#ffff00"
                                            : isDrawn
                                                ? "#ff0000"
                                                : "#fff",
                                }}
                            >
                                {num}
                            </span>
                        </div>
                    );
                })}

                {Gridcover && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: GRID_COLS * CELL_SIZE,
                            height: GRID_ROWS * CELL_SIZE,
                            // background: "rgba(0,0,0,0.4)",
                        }}
                    />
                )}
            </div>
        );
    }
}

export default KenoGrid;
